import React from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@codes/ui-kit/components/ui/dialog';

import { AgentForm } from './AgentForm';

export interface CreateAgentDialogProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    onFormSuccess: () => void;
}

export const CreateAgentDialog: React.FC<CreateAgentDialogProps> = ({ isOpen, onOpenChange, onFormSuccess }) => {
    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent className="p-0 max-w-[992px]">
                <DialogHeader>
                    <DialogTitle>Add Agent</DialogTitle>
                </DialogHeader>
                <AgentForm
                    mode="create"
                    agentId={null}
                    onFormSuccess={onFormSuccess}
                    className="!shadow-none !border-none"
                />
            </DialogContent>
        </Dialog>
    );
};
